const DEFAULT_FILTERS = {
  employee: "all",
  leaveType: "all",
  status: "all",
  dateRange: { from: undefined, to: undefined },
};

export function areManagerFiltersEqual(a, b) {
  return (
    a.employee === b.employee &&
    a.leaveType === b.leaveType &&
    a.status === b.status &&
    a.dateRange?.from?.getTime?.() === b.dateRange?.from?.getTime?.() &&
    a.dateRange?.to?.getTime?.() === b.dateRange?.to?.getTime?.()
  );
}

export function cloneManagerLeaveFilters(filters) {
  return {
    employee: filters.employee,
    leaveType: filters.leaveType,
    status: filters.status,
    dateRange: {
      from: filters.dateRange?.from,
      to: filters.dateRange?.to,
    },
  };
}

export function countActiveFilters(filters = DEFAULT_FILTERS) {
  let count = 0;
  if (filters.employee && filters.employee !== "all") count += 1;
  if (filters.leaveType && filters.leaveType !== "all") count += 1;
  if (filters.status && filters.status !== "all") count += 1;
  if (filters.dateRange?.from || filters.dateRange?.to) count += 1;
  return count;
}

export function getDefaultLeaveFilters() {
  return cloneManagerLeaveFilters(DEFAULT_FILTERS);
}

export { DEFAULT_FILTERS as DEFAULT_MANAGER_LEAVE_FILTERS };
